import React from 'react';

function SuccessStep() {
  return (
    <div className='flex flex-col items-center text-center text-sm [&>img]:mb-6 [&>strong]:pt-4'>
      <img width={64} height={63} src='/img/success_icon.svg' alt='Ícone verde de sucesso' />
      <span>Sua solicitação de transferência foi recebida com sucesso e será realizada no próximo dia útil.</span>
    </div>
  );
}

export default SuccessStep;
